import { Component, OnInit } from '@angular/core';
import { DataLoginModel } from '../../../models/dataLoginModel';

@Component({
  selector: 'app-home-emp',
  templateUrl: './home-emp.component.html',
  styleUrls: ['./home-emp.component.css']
})
export class HomeEmpComponent implements OnInit {
  
  dataUsuario: DataLoginModel;

  constructor() { }

  ngOnInit() {
    this.dataUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
  }

}
